import { useQuery, QueryKey } from '@tanstack/react-query';
import { request, Variables } from 'graphql-request';
import useGraphqlRequestParams from './useGraphqlRequestParams';

type Options<T> = {
  queryKey: QueryKey;
  query: string;
  variables?: Variables;
  enabled?: boolean | undefined;
  select?: (data: any) => any;
  responseMock?: T;
  staleTime?: number;
  onError?: () => void;
  envId?: string;
  keepPreviousData?: boolean;
};

const useGraphqlQuery = <T>({
  queryKey,
  query,
  variables,
  enabled,
  select,
  responseMock,
  staleTime = Infinity,
  onError,
  envId,
  keepPreviousData,
}: Options<T>) => {
  const { accessToken, environmentId, gqlEndpoint } = useGraphqlRequestParams({
    envId,
  });

  return useQuery<T>({
    queryKey,
    queryFn: async () =>
      responseMock ??
      request(gqlEndpoint, query, variables, {
        authorization: `Bearer ${accessToken}`,
      }),
    enabled: environmentId !== undefined && !!accessToken && enabled,
    select,
    staleTime,
    onError: onError,
    keepPreviousData,
  });
};

export default useGraphqlQuery;
